module.exports = __webpack_public_path__ + "media/images/vr/index-header-section-bg-da8da2d076a461f9fa6fc90f28774344.jpg";